import { Phone, Mail, Copy, MapPin } from "lucide-react";
import { toast } from "sonner";
import { EMAIL, PHONE, PHONE_TEL } from "../data";

const copy = (v, label) => {
  if (!navigator.clipboard) return toast.error("Não foi possível copiar");
  navigator.clipboard.writeText(v).then(
    () => toast.success(`${label} copiado`),
    () => toast.error("Não foi possível copiar")
  );
};

const Card = ({ id, icon: I, label, value, href, color }) => (
  <div className={`contact-card ${color}`} data-testid={`contact-${id}-card`}>
    <div className="icon-box"><I size={22} /></div>
    <span className="eyebrow mt-8 !text-[var(--muted)]">{label}</span>
    <a href={href} data-testid={`contact-${id}-link`} className="contact-value">{value}</a>
    <button onClick={() => copy(value, label)} data-testid={`contact-copy-${id}-btn`} className="copy-btn">
      <Copy size={14} /> Copiar
    </button>
  </div>
);

export const Contact = () => (
  <section id="contacto" data-testid="contact-section" className="section contact-section">
    <div className="wrap">
      <span className="eyebrow">Contacto</span>
      <h2 className="h1-contact mt-5">Vamos falar do<br />seu projeto?</h2>
      <p className="mt-6 text-base md:text-lg text-[var(--text-2)]">Peça informações ou um orçamento sem compromisso.</p>
      <div className="grid md:grid-cols-2 gap-6 mt-14">
        <Card id="phone" icon={Phone} label="Telefone" value={PHONE} href={`tel:${PHONE_TEL}`} color="is-red" />
        <Card id="email" icon={Mail} label="E-mail" value={EMAIL} href={`mailto:${EMAIL}`} color="is-blue" />
      </div>
      <p className="mt-10 flex items-center gap-2 text-[var(--muted)]" data-testid="contact-area">
        <MapPin size={16} className="text-[var(--red)]" /> Área de atuação: <strong className="text-white font-semibold">Loures e Grande Lisboa</strong>
      </p>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)]">
    <div className="wrap py-10 flex flex-col md:flex-row gap-4 justify-between text-sm text-[var(--muted)]">
      <span>SR Soluções Elétrica — soluções técnicas com profissionalismo e confiança.</span>
      <span>© {new Date().getFullYear()} SR Soluções Elétrica</span>
    </div>
  </footer>
);
